export default {
  teamTitle: 'Unisciti al nostro team',
  teamText:
    'Coltiviamo l’eccellenza,\nproprio come facciamo con i nostri lieviti.',
  info: `Via Verdi,\n32 31046 Oderzo - TV\nItalia`,
}
